;
const bind_price_fields = () => {
  const input_price_format = (input) => {
    const selectionStart = input.selectionStart;
    const selectionEnd = input.selectionEnd;

    let value = input.value.replace(/\D/g, '');

    if (!value) {
      input.value = '';
      return;
    }

    const beforeLength = input.value.length;

    value = new Intl.NumberFormat('fr-FR').format(value);
    input.value = `${value}`;

    const afterLength = input.value.length;
    const diff = afterLength - beforeLength;

    input.setSelectionRange(selectionStart + diff, selectionEnd + diff);
  };

  document.querySelectorAll('input.price-format:not(.done)').forEach(el => {
    el.classList.add('done');
    el.addEventListener('input', () => input_price_format(el));
  });
};

const restrict_input_fields = () => {
  document.querySelectorAll('.input-only-number input[type="text"]').forEach(el => {
    el.setAttribute('inputmode', 'numeric');
    el.addEventListener('input', () => {
      el.value = el.value.replace(/[^0-9]/g, '');
    });
  });

  document.querySelectorAll('.input-only-letter input[type="text"]').forEach(el => {
    el.addEventListener('input', () => {
      el.value = el.value.replace(/[^a-zA-Z\u00C0-\u024F\s-]/g, '');
    });
  });
};

(function ($) {
  $(document).ready(() => {

    /*HEADER*/
    const toggleHeaderMenu = () => {

      const header = $("#header-main-nav")
      const menu = $("#menu-header")

      header.toggleClass("open")

      if (header.hasClass("open")) {

        menu.animate({
          height: menu[0].scrollHeight + 'px'
        }, 500, function () {
          menu.height("auto")
        })
      }
      else {
        menu.animate({
          height: 0
        }, 500)
      }

    }

    function toggleHeaderSubmenu() {
      let submenu = $(this).find(".sub-menu")

      if (submenu.length) {
        submenu = submenu[0]

        if ($(this).hasClass("open")) {
          closeAllHeaderSubmenu(true)
        } else {
          closeAllHeaderSubmenu(false)
          $(submenu).height(submenu.scrollHeight)

          /*if ($(this).closest('#menu-item-311').length === 0)
            $(submenu).width(submenu.scrollWidth)*/

          $("#header-overlay").addClass("open")
          $(this).toggleClass("open")
        }
      }

    }

    function closeAllHeaderSubmenu(hideOverlay) {
      $(".sub-menu").height(0);
      //$(".sub-menu").width("auto");
      $(".menu-item-has-children").removeClass("open");

      if (hideOverlay)
        $("#header-overlay").removeClass("open")
    }

    function hideTopNav() {
      console.log(window.innerWidth)
      if (window.scrollY > 0 && window.innerWidth < 1200)
        $("#header-top-nav").addClass("hide");
      else
        $("#header-top-nav").removeClass("hide");
    }

    const toggleHeaderSearch = () => {
      window.scrollTo(0, 0)
      document.getElementById("search-form-overlay").classList.toggle("open")
      document.getElementById("search-form-wrapper").classList.toggle("open")
    }

    //duplicate contact and partner link 
    //add picture for mega menu desktop
    const addCustomLinkToHeaderNav = () => {
      const contact = $("#link_contact").clone();
      const partner = $("#link_partners").clone();

      $("ul#menu-header").append(
        $("<li></li>").addClass("menu-item menu-item-cta").append(contact)
      );
      $("ul#menu-header").append(
        $("<li></li>").addClass("menu-item menu-item-cta").append(partner)
      );

      //add mega menu image
      const mm_a = $("<a target='_blank'></a>").attr("url",mm_url)
      const mm_li = $("<li></li>").css("background-image","url('"+mm_image+"')").addClass("mega_menu_picture").append(mm_a);

      $("#menu-item-311 ul").append(mm_li)
    }

    /*EVENTS*/
    $(".menu-item-has-children").on("click", toggleHeaderSubmenu)
    $("#header-overlay").on("click", closeAllHeaderSubmenu)
    $("#burger").on("click", toggleHeaderMenu)
    $("#link_search").on("click", toggleHeaderSearch)
    $("#search-form-overlay").on("click", () => toggleHeaderSearch(true))
    

    $(window).on("scroll", hideTopNav)
    $(window).on("resize", hideTopNav)
    hideTopNav()

    addCustomLinkToHeaderNav()

    /* LIGHTBOX */
    function showLightBox(){
      const img = $(this).data("src");

      if(img !== "#"){
        $(".lightbox_wrapper img").attr("src",img)
        $(".lightbox_wrapper").addClass("open")
      }
      
    }
    function hideLightBox(){
      $(".lightbox_wrapper").removeClass("open")
    }
    
    $(".lb").on("click",showLightBox)
    $(".lightbox_wrapper button").on("click",hideLightBox)
    $(".lightbox_wrapper").on("click",hideLightBox)

    /* Accessibilite CTA */
    $("#link_accessibility").on("click",toggleAccessibilityCta)
    function toggleAccessibilityCta(){
      $(this).toggleClass("on")

      if($(this).hasClass("on")){
        $(this).width($(this).width()).text("DÉSACTIVER")
      }else{
        $(this).text("ACCESSIBILITÉ").width('auto')
      }

    }

  });


  document.addEventListener("DOMContentLoaded", () => {

    /* MODAL */
    MicroModal.init({
      onShow: modal => {
        const content = modal.querySelector('.modal__content');
        if (content) content.scrollTop = 0;
      }
    });

    document.addEventListener('wheel', function (e) {
      const modalContent = e.target.closest('.no_smooth_scroll');
      if (modalContent) {
        e.stopPropagation();
      }
    }, { passive: false });

    /* UTM */

    /* REFERER */

    document.querySelectorAll('input[type="hidden"][id^="field_referer_"]').forEach((el) => {
      el.value = window.location.href;
    });
  });

  // Pagination
  if (document.getElementById('programs-results-wrapper') == null) {
    document.querySelectorAll('.pagination-link').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const page = e.target.dataset.page;
        const params = new URLSearchParams(window.location.search);
        params.set('page', page);
        console.log(params.toString());
        window.location.search = params.toString();
      });
    });
  }

  // Price fields
  bind_price_fields();

  // Restrict input fields
  restrict_input_fields();

  //bold in select input
  $("select").on("change", function () {
    $(this).css("font-weight", "bold");
  });
})(jQuery);
